import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { take } from 'rxjs/operators';
import { Invitation } from 'src/app/shared/models/invitation.model';
import { Invite } from 'src/app/shared/models/invite.model';
import { GlobalService } from 'src/app/shared/services/global.service';
import { InvitationsService } from 'src/app/shared/services/invitations.service';
import { AuthService } from '../../account/auth.service';
import { User } from '../../account/user.model';

@Component({
    selector: 'app-invitations',
    templateUrl: './invitations.component.html',
    styleUrls: ['./invitations.component.scss'],
    standalone: false
})
export class InvitationsComponent implements OnInit {
  @Output() inviteLoadingComplete = new EventEmitter();
  @Output() invitesComplete = new EventEmitter();
  userId: string = null;
  User: User = null;
  invitations: Invitation[];
  isLoading: boolean = true;
  constructor(
    private _InvitationService: InvitationsService,
    private authService: AuthService,
    public globalService: GlobalService
  ) {}

  async ngOnInit() {
    this.User = await this.authService.autoLogin(1);
    if (this.User != null)
    {
      this.userId = this.User.id;
      this.invitations = await this._InvitationService.getInvitations(
        this.userId,
        false
      );
      this.invitations.map((a) => {
        a['resolved'] = false;
      });
      this.isLoading = false;
      this.inviteLoadingComplete.emit();
      if (this.invitations.length == 0) this.invitesComplete.emit();
    } else this.invitesComplete.emit();
  }

  CheckComplete() {
    if (this.invitations.findIndex((a) => a['resolved'] == false) < 0)
      this.invitesComplete.emit();
  }

  async Accept(invitation: Invitation) {
    var invite: Invite = new Invite();
    invite.userId = this.userId;
    invite.groupId = invitation['groupId'];
    invite.memberId = invitation['memberId'];
    await this._InvitationService.acceptInvitation(invite);
    invitation['resolved'] = true;
    this.CheckComplete();
  }

  async Reject(invitation: Invitation) {
    var invite: Invite = new Invite();
    invite.userId = this.userId;
    invite.groupId = invitation['groupId'];
    invite.memberId = invitation['memberId'];
    await this._InvitationService.declineInvitation(invite);
    invitation['resolved'] = true;
    this.CheckComplete();
  }

  async Suppress(invitation: Invitation) {
    var invite: Invite = new Invite();
    invite.userId = this.userId;
    invite.groupId = invitation['groupId'];
    invite.memberId = invitation['memberId'];
    await this._InvitationService.suppressInvitation(invite);
    invitation['resolved'] = true;
    this.CheckComplete();
  }
}
